"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _UnknownTooltip = _interopRequireDefault(require("./UnknownTooltip"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function OwnedLicenseExpire(row) {
  var targetEntity = row.targetEntity;
  if (targetEntity) {
    return /*#__PURE__*/_react["default"].createElement("span", null, "Expired license of ", /*#__PURE__*/_react["default"].createElement("b", null, targetEntity));
  }
  return /*#__PURE__*/_react["default"].createElement("span", null, "Expired license of an unknown user", /*#__PURE__*/_react["default"].createElement(_UnknownTooltip["default"], null));
}
var _default = exports["default"] = OwnedLicenseExpire;